/* eslint-disable css-modules/no-unused-class */
import { FC } from 'react';
import { ProgressBarProps } from './progressBarTypes';
import styles from './progressBar.module.scss';

const ProgressBar: FC<ProgressBarProps> = (props: ProgressBarProps) => {
    const { direction, text, value, bgColor, valueColor } = props;

    return (
        <div className={styles.wrapper}>
            {text && <div className={styles['title-value']}>{`${value}%`}</div>}
            <div
                data-testid="progress-bar"
                className={styles[direction === 'horizontal' ? 'progress-bar-horizontal' : 'progress-bar-vertical']}
                style={{ background: bgColor || 'initial' }}
            >
                <div
                    className={styles.value}
                    style={{ '--value': `${value}%`, background: valueColor || 'initial' } as any}
                ></div>
            </div>
            {text && <div className={styles.text}>{text}</div>}
        </div>
    );
};

export default ProgressBar;
